import React from 'react';
import PropTypes from 'prop-types';
import AppConfig from '../../appConfig';
import { startTourButtonEvents } from '../../enums/GoogleTagManagerEvents';
import googleTagManagerEvents from '../../helpers/GoogleTagManagerEventsWrapper';

const StartTourButton = googleTagManagerEvents('button', startTourButtonEvents);

class HelpTourWelcome extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showHeaderImage: true,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
        const HELP_TOUR_WELCOME_HEIGHT = 662; // px - Height of the help tour welcome popup
        const rootContainerElement = document.getElementById('root-container');

        if (rootContainerElement) {
            const rootContentHeight = rootContainerElement.clientHeight;

            if (rootContentHeight < HELP_TOUR_WELCOME_HEIGHT) {
                this.setState({ showHeaderImage: false });
            } else {
                this.setState({ showHeaderImage: true });
            }
        }
    };

    onTourStartClick = () => {
        this.props.onTourStart();
    };

    onClose = () => {
        this.props.onClose();
    };

    renderNewUserContent() {
        return (
            <div className="flex-it grow space-between column help-tour-welcome-content">
                <div className="flex-it justify-center text-center padded-bottom-24">
                    <h2>Welcome to {AppConfig.constants.applicationName}!</h2>
                </div>
                <div className="text-start">
                    <p>We’d like to show you around so you can get the most out of TractIQ to:</p>
                    <ol>
                        <li>
                            Find new self storage markets for ground up development or acquisition.
                        </li>
                        <li>
                            Analyze storage sites or locations and understand the competitive
                            landscape.
                        </li>
                        <li>
                            Leverage our many layer libraries like residential and commercial
                            development, risk maps, and traffic.
                        </li>
                    </ol>
                </div>
            </div>
        );
    }

    renderExistingUserContent() {
        return (
            <div className="flex-it grow space-between column help-tour-welcome-content">
                <div className="flex-it justify-center text-center padded-bottom-24">
                    <h2>{AppConfig.constants.applicationName} has been updated</h2>
                </div>
                <div className="text-start">
                    <p>
                        Since you were last here, we've made a major update. We'd like to show you
                        around so you can get the most of the platform.
                    </p>
                    <p>Who knows? Maybe you'll even discover some new features!</p>
                </div>
            </div>
        );
    }

    render() {
        const { existingUser, helpTourRef } = this.props;
        const { showHeaderImage } = this.state;

        return (
            <div className="flex-it column help-tour-welcome" ref={helpTourRef}>
                <div className="flex-it flex-end help-tour-welcome-header">
                    <button className="clickable" onClick={this.onClose}>
                        <i className="material-icons">close</i>
                    </button>
                    <div className="flex-it justify-center">
                        {showHeaderImage && (
                            <img
                                src={`${AppConfig.constants.assetsBaseURL}/svg/take-a-tour.svg`}
                                alt="take-a-tour"
                            />
                        )}
                    </div>
                </div>

                {existingUser ? this.renderExistingUserContent() : this.renderNewUserContent()}

                <div className="help-tour-welcome-actions">
                    <StartTourButton className="btn-raised" onClick={this.onTourStartClick}>
                        Get started
                    </StartTourButton>
                </div>
            </div>
        );
    }
}

HelpTourWelcome.propTypes = {
    onClose: PropTypes.func.isRequired,
    onTourStart: PropTypes.func.isRequired,
    helpTourRef: PropTypes.func,
    existingUser: PropTypes.bool.isRequired,
};

HelpTourWelcome.defaultProps = {
    helpTourRef: undefined,
};

export default HelpTourWelcome;
